import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/slider-arrow-left-icon.svg'
import _imports_1 from '@/assets/icons/slider-arrow-right-icon.svg'


const _hoisted_1 = { class: "navigation-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.carousel.prev()))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("img", { src: _imports_0 }, null, -1)
      ]))]),
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.carousel.next()))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("img", { src: _imports_1 }, null, -1)
      ]))])
    ]),
    _createVNode($setup["Carousel"], {
      ref: "carousel",
      itemsToShow: $setup.itemsToShow,
      transition: 200,
      wrapAround: false,
      "mouse-drag": false,
      "touch-drag": false,
      itemsToScroll: !$setup.isLargeScreenBreakpoint ? 1 : 2
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.optionalUpgrades, (slide) => {
          return (_openBlock(), _createBlock($setup["Slide"], {
            class: "slide",
            key: slide._id + new Date().getTime()
          }, {
            default: _withCtx(() => [
              _createVNode($setup["UpgradeOption"], _mergeProps({ ref_for: true }, slide, {
                "is-selected": $props.selectedUpgradeFromForm?.some((u) => u._id === slide._id) || false,
                "onUpdate:selected": ($event: any) => ($props.handleUpgradeSelection(slide, $event))
              }), null, 16, ["is-selected", "onUpdate:selected"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["itemsToShow", "itemsToScroll"])
  ], 64))
}